import mixpanel from "mixpanel-browser";

import { MixpanelActions } from "@src/types/index.interface";

import type { Session } from "next-auth";

const MIXPANEL_CONFIG = {
  batch_requests: false,
  debug: true,
};

const getProfileOptions = (user) =>
  user
    ? {
        id_beyond: user.id_beyond,
        $email: user.email,
        name: `${user.name} ${user.lastname} ${user.scndlastname}`,
        country:
          typeof user.country === "string" ? user.country : user.country.value,
        id18: user.id18,
        professional_ID: user.professional_ID,
        specialism:
          typeof user.specialism === "string"
            ? user.specialism
            : user.specialism.value,
      }
    : null;

const Mixpanel = {
  tryCatch({ event, ...args }) {
    try {
      if (event === "track")
        console.log("🔬 4 mixpanel events: ", event, ...Object.values(args));

      mixpanel.init(process.env.MIXPANELTOKEN, {
        // debug: process.env.ENVIRONMENT === "development",
        ...MIXPANEL_CONFIG,
      });

      switch (event) {
        case "identify":
          mixpanel.identify(...Object.values(args));
          break;
        case "register":
          mixpanel.register(...Object.values(args));
          break;
        case "track":
          mixpanel.track(...Object.values(args));
          break;
        case "people.set":
          mixpanel.people.set_once(...Object.values(args));
          break;
      }
    } catch (e) {
      console.log("mixpanel error:", e);
    }
  },

  init() {
    // throw new Error("Mixpanel");
    // mixpanel.init(process.env.MIXPANELTOKEN, { debug: process.env.ENVIRONMENT === "development" });
  },

  indentifyUser({ user }) {
    console.log("🔬 2 indentifyUser", user);
    this.tryCatch({ event: "identify", user });
    // mixpanel.identify(user);
  },

  createSuperProperties(options) {
    console.log("🔬 createSuperProperties", options);
    // mixpanel.register(options);
    this.tryCatch({ event: "register", options });
  },

  trackAction({
    action,
    options = {},
    user,
  }: {
    action: MixpanelActions;
    options?: {};
    user: Session | null;
  }) {
    const profileOptions = getProfileOptions(user);

    console.log(
      "🔬 1 trackAction",
      action,
      options,
      profileOptions,
      profileOptions?.$email
    );

    if (user && profileOptions) {
      this.indentifyUser({ user: profileOptions.$email });
      console.log("🟡 SET_PROFILE");
      this.setProfile({
        options: profileOptions,
      });
    }

    this.tryCatch({
      event: "track",
      action,
      options,
    });
  },

  setProfile({ options }) {
    console.log("🔬 3 setProfile", options);
    // mixpanel.people.set(options);
    this.tryCatch({ event: "people.set", options });
  },
};

export default Mixpanel;
